<template>
  <v-container fluid fill-height ma-0 pa-0 >
    <v-layout fill-height pa-0>
      <v-flex xs12 px-0>
        <v-layout column fill-height justify-start ma-0 pa-0>
          <v-toolbar dense flat color="white" height="42">
            <v-toolbar-title class="subtitle-2 back--text text-uppercase">
              <v-layout fill-height align-center ma-0 pb-2 pl-2 style="position: relative">

                <v-menu
                  v-model="bar.filter.open"
                  :close-on-content-click="false"
                  :close-on-click="true"
                  :nudge-width="100"
                  offset-y
                  bottom
                >

                  <template v-slot:activator="{ on }">
                    <v-flex shrink v-for="(page, index) in getTabs" :key="index">
                      <v-layout :class="getTabs[activeTab] == page && page == 'events' ? 'journal-tab-button active' : 'journal-tab-button'" 
                      :data-testid="$options.name + '__tab__' + page"
                      @click.stop="() => onJournalBattonClick(page, index)" align-center>
                        <svg-icon
                          :color="'blacktext'"
                          :name="page"
                          width="20"
                        />
                          <v-flex shrink px-2>
                          <span class="blacktext--text">{{ $t(page) }}</span> 
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </template>

                  <filter-bar
                    v-show="bar.filter.open"
                    :size="500"
                    :data="getRecords"
                    :columns="getDescriptor.columns"
                    :columnsFilter="getFilterColumns"
                    :mode="bar.filter.mode"
                    @filter="(payload) => applyFilter(payload)"
                    @close="()=>{bar.filter.open = false}"
                  />                

                </v-menu>
              </v-layout>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-flex style="position: relative">
            <v-layout class="white" column fill-height px-4>
              <v-layout fill-height>
                <wrapper 
                  ref="descriptor_wrapper"
                  :data="getRecords"
                  :descriptor="getDescriptor"
                  :filter="getFilter"
                  :pdfDialogShow="getPdfDialogShow"
                  @sort="(item) => sortTable(item)"
                  @select="(payload) => selectRecord(payload)"
                  @value="(row, item) => clickValue(row, item)"
                  @pdfReportsClose="(e) => onPdfReportsClose(e)"
                />

              </v-layout>
              <v-layout class="text-xs-center pt-2" justify-center>
                <v-btn :disabled="getPage == 0" flat small icon 
                :data-testid="$options.name + '__btn__' + 'first_page'"
                @click="() => moveToPage('first')" class="transparent">
                  <v-icon>first_page</v-icon>
                </v-btn>
                <v-btn :disabled="getPage == 0" flat small icon 
                :data-testid="$options.name + '__btn__' + 'prevPage'"
                @click="() => prevPage()" class="transparent">
                  <v-icon>chevron_left</v-icon>
                </v-btn>
                <v-btn :data-testid="$options.name + 'v-btn' + 'getPage1'" small icon flat class="transparent">{{getPage + 1}}</v-btn>
                <v-btn :disabled="getRecords.length < pageLimit || getPage == totalPages" small icon flat 
                :data-testid="$options.name + '__btn__' + 'nextPage'"
                @click="() => nextPage()" class="transparent">
                  <v-icon>chevron_right</v-icon>
                </v-btn>
                <v-btn :disabled="getRecords.length < pageLimit || getPage == totalPages" small icon flat 
                :data-testid="$options.name + '__btn__' + 'last_page'"
                @click="() => moveToPage('last')" class="transparent">
                  <v-icon>last_page</v-icon>
                </v-btn>            
              </v-layout>

            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

  </v-container>

</template>

<script lang="ts">
import Vue from 'vue'
import filterBar from '@/nms/components/partials/filter-bar.vue'
import tableDescriptor from '@/nms/pages/events/eventsTableDescriptor.js'
import wrapper from '@/nms/components/partials/descriptor-wrapper.vue'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import myFont from '@/nms/assets/RobotoCondensed-Regular-normal.js'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'

// Типы
interface TableColumn {
  title: string
  value: string
  type?: string
  width?: string
  [key: string]: any
}

interface TableData {
  columns: TableColumn[]
  rows: Record<string, any>[]
}

interface OptionsColumns {
  [key: string]: { width: string }
}

interface OptionsData {
  columns: OptionsColumns
}

interface FilterData {
  date?: {
    startRT?: string
    endRT?: string
    start?: string
    end?: string
  }
  [key: string]: any
}

interface BarState {
  filter: { open: boolean }
}

interface DialogState {
  pdf: { show: boolean }
}

interface SyslogRecord {
  $id?: string
  name?: string
  rt?: string
  name_path?: string
  idPath?: string
  info?: { idPath?: string }
  [key: string]: any
}

interface CustomQueryResponse {
  data?: {
    data?: SyslogRecord[]
    pages?: number
    total?: number
  }
  [key: string]: any
}

interface CsvRow {
  [key: string]: any
}

export default Vue.extend({
  name: 'EVENTS_JOURNAL_SYSLOG',

  components: {
    filterBar,
    wrapper,
    svgIcon,
  },

  props: {},

  data(): {
    activeTab: number
    bar: BarState
    dialog: DialogState
    records: SyslogRecord[]
    options: OptionsData
    filter: FilterData
    search: string
    sort: string
    filterColumns: Record<string, any>
    filterPath: string | null
    table: TableData
    pageLimit: number
    page: number
    totalPages: number
    totalRecords: number
    nextPageButton: boolean
  } {
    return {
      activeTab: 1,
      bar: {
        filter: { open: false },
      },
      dialog: {
        pdf: { show: false }
      },
      records: [],
      options: {
        columns: {
          text: { width: '40%' },
          timestamp: { width: '20%' },
          check: { width: '5%' },
          actions: { width: '20%' }
        },
      },
      filter: {},
      search: '',
      sort: '',
      filterColumns: {},
      filterPath: null,
      table: {
        columns: [],
        rows: []
      },
      pageLimit: 40,
      page: 0,
      totalPages: 1,
      totalRecords: 1,
      nextPageButton: true,
    }
  },

  computed: {
    getRecords(): SyslogRecord[] {
      return []
      // return this.records
    },

    getDescriptor(): Record<string, any> {
      return tableDescriptor || {}
    },

    getFilter(): FilterData {
      return this.filter
    },

    getTabs(): string[] {
      return ['filter', 'events', 'pdf', 'csv']
    },

    getFilterColumns(): Record<string, any> {
      return this.filterColumns
    },

    getPage(): number {
      return this.page
    },

    getTable(): TableData {
      let t: TableData

      if (this.filterPath) {
        const t$ = this.$merge({}, this.table) as TableData
        t$.rows.forEach(row => {
          if (row.name_path) {
            if (this.filterPath === 'showFullPath' || this.filterPath === 'hideRoot') {
              row.name_path = row.name_path.split('/').slice(2).join('/')
            }
            if (this.filterPath === 'showL2orNearestFacility') {
              const path$ = row.name_path.split('/').slice(1)
            }
            if (this.filterPath === 'showNearestFacility') {
              if (!row.idPath && row.info?.idPath) {
                row.idPath = row.info.idPath
              }
              const path$ = row.name_path.split('/').slice(1)
            }
          }
        })
        t = t$
      } else {
        const t$ = this.$merge({}, this.table) as TableData
        if (t$.rows.length) {
          t$.rows.forEach(row => {
            if (row.name_path) {
              row.name_path = row.name_path.split('/').slice(2).join('/')
            }
          })
        }
        t = t$
      }

      if (this.search.length) {
        const searchLower = this.search.toLowerCase()
        t.rows = t.rows.filter(row => {
          return (row.name && row.name.toLowerCase().indexOf(searchLower) > -1) ||
                 (row.maintenance_company_name && row.maintenance_company_name.toLowerCase().indexOf(searchLower) > -1) ||
                 (row.crumbs && row.crumbs.toLowerCase().indexOf(searchLower) > -1)
        })
      }

      if (this.sort) {
        const isDescending = this.sort.charAt(0) === '-'
        const fieldName = isDescending ? this.sort.slice(1) : this.sort
        const direction = isDescending ? -1 : 1
        t.rows = [...t.rows].sort(this.$compare(fieldName, direction))
      }

      return t
    },

    getPdfDialogShow(): boolean {
      return this.dialog.pdf.show
    },
  },

  watch: {
    filterColumns: {
      handler(): void {
        this.setup()
      },
      deep: true
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    async setup(): Promise<void> {
      await this.loadRecords()
    },

    sortTable(item: TableColumn): void {
      if (this.sort === item.value) {
        this.sort = '-' + item.value
      } else {
        this.sort = item.value
      }
    },

    applyFilter(barFilter: FilterData): void {
      console.log(this.$options.name, 'applyFilter', 'barFilter', barFilter)
      this.filter = barFilter
      this.loadRecords()
    },

    async loadRecords(): Promise<void> {
      try {
        this.table = { columns: [], rows: [] }
        
        let filter: FilterData = {}
        if (Object.keys(this.filter).length) {
          filter = await this.prepareFilter()
        }
        filter.page = this.page

        const events = await this.$bridge.customQuery('alarm', 'logs_enode/', {
          table: 'syslogs',
          filter: filter,
          count: this.pageLimit,
          page: this.page,
        }, 'post') as CustomQueryResponse

        if (events) {
          this.totalPages = events?.data?.pages || 1
          this.totalRecords = events?.data?.total || 1
          this.records = events?.data?.data || events?.data || events
          this.$set(this.table, 'rows', this.records)
        }
      } catch (err) {
        console.error('CATCH', this.$options.name, 'loadRecords', 'error', err)
      }
    },

    async prepareFilter(): Promise<FilterData> {
      const $filter: FilterData = {}

      if (!Object.keys(this.filter).length) {
        return $filter
      }

      Object.keys(this.filter).forEach(key => {
        const val = key.split('.')

        if (val?.length > 1) {
          if (!$filter[val[0]]) {
            $filter[val[0]] = []
          }
          $filter[val[0]].push({ [val[1]]: this.filter[key] })
        } else {
          if (key === 'date') {
            console.log(this.$options.name, 'prepareFilter key date', key)
            console.log(this.$options.name, 'prepareFilter this.filter.date', this.filter.date)
            if (this.filter.date?.startRT) {
              $filter.fromRt = this.filter.date.startRT
            }
            if (this.filter.date?.endRT) {
              $filter.toRt = this.filter.date.endRT
            }
          } else {
            $filter[key] = this.filter[key]
          }
        }
      })

      return $filter
    },

    reportsPDF(): void {
      console.log(this.$options.name, 'reportsPDF')
      this.dialog.pdf.show = !this.dialog.pdf.show
    },

    onPdfReportsClose(): void {
      this.dialog.pdf.show = false
    },

    generatePDF(): void {
      let table_wrapper = this.$refs['descriptor_wrapper']
      if(table_wrapper?.generatePDF) {
        table_wrapper.generatePDF()
      }
      return
    },

    csvExport(): void {
      let table_wrapper = this.$refs['descriptor_wrapper']
      if(table_wrapper?.csvExport) {
        table_wrapper.csvExport()
      }
      return
    },

    getFormattedDate(rows: Record<string, any>[]): Record<string, any>[] {
      const result: Record<string, any>[] = []
      rows.forEach(row => {
        const newRow: Record<string, any> = {}
        Object.keys(row).forEach(key => {
          if (row[key] instanceof Date || key === 'rt') {
            newRow[key] = (this as any).$moment(row[key]).format('DD MM YYYY HH:mm')
          } else {
            newRow[key] = this.$getTranslate(row[key])
          }
        })
        result.push(newRow)
      })
      return result
    },

    selectRecord(record: SyslogRecord): void {
      console.log(this.$options.name, 'RECORD SELECTED: ', record)
    },

    clickValue(row: SyslogRecord, item: TableColumn): void {
      console.log(this.$options.name, 'clickValue', 'row: ', row, 'item: ', item)
    },

    nextPage(): void {
      if (!this.nextPageButton || !this.getTable.rows.length || this.getTable.rows.length < this.pageLimit) return
      this.page++
      this.loadRecords()
    },

    prevPage(): void {
      if (this.getPage == 0) return
      this.page--
      this.loadRecords()
    },

    moveToPage(val: string): void {
      console.log(this.$options.name, 'moveToPage', 'val: ', val)
      if (val === 'first') {
        if (this.getPage === 0) return
        this.page = 0
        this.loadRecords()
      }
      if (val === 'last') {
        if (this.getPage === this.totalPages) return
        this.page = this.totalPages
        this.loadRecords()
      }
    },

    async onJournalBattonClick(page: string, index: number): Promise<void> {
      console.log(this.$options.name, 'onJournalBattonClick', page, index)
      if (page === 'pdf') {
        // this.reportsPDF()
        this.generatePDF()
      }
      if (page === 'csv') {
        this.csvExport()
      }
      if (page === 'filter') {
        this.$set(this.bar.filter, 'open', !this.bar.filter.open)
      }
    },
  },
})
</script>

<style>
.journal-tab-button {
  font-size: 14px !important;
  height: 36px;
  background-color: #ebebeb !important;
  border-left: solid 1px #DCDCDC !important;
  border-right: solid 1px #DCDCDC !important;
  border-top: solid 1px #DCDCDC !important;
  border-bottom: solid 1px #DCDCDC !important;
  padding: 4px 20px 4px 20px;
  cursor: pointer;
}
</style>
